export const USERS_COLUMNS = {
	email: "name",
	active: "boolean_mkswa5n8",
	firstname: "text_mkqedcqc",
	favoriteServices: "favoriteservices",
	sso: "ssocheck",
	lastname: "text_mkqepf8e",
	picture: "file_mkqwz5hn",
	role: "status",
	services: "board_relation_mkqe46e2",
	language: "dropdown_mkvdmqfb",
};

export enum USER_ROLES {
	Admin = "Admin",
	Member = "Member",
	Viewer = "Viewer",
}

export const UserRolesColorMapping: Record<
	USER_ROLES,
	"primary" | "secondary" | "success"
> = {
	[USER_ROLES.Admin]: "primary",
	[USER_ROLES.Member]: "secondary",
	[USER_ROLES.Viewer]: "success",
};
